import React from 'react';
import { TiTick } from '@react-icons/all-files/ti/TiTick';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { Stepper, Step, StepConnector } from '@material-ui/core';
import classNames from 'classnames';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    position: 'absolute',
    right: 0,
    bottom: 8,
    [theme.breakpoints.down('sm')]: {
      right: '-14px',
      bottom: '0',
    },
    [theme.breakpoints.down('md')]: {
      right: '-14px',
    },
  },
  circle: {
    height: 24,
    width: 24,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#44D7B6',
    [theme.breakpoints.down('sm')]: {
      backgroundColor: '#34c759',
    },
  },
  activatedCircle: {
    backgroundColor: '#44D7B6',
    [theme.breakpoints.down('sm')]: {
      backgroundColor: '#34c759',
    },
  },
  inactivatedCircle: {
    backgroundColor: '#C9D5E3',
  },
  tickCustom: {
    color: 'white',
    fontSize: 19,
  },
  customStepper: {
    padding: 0,
  },
  customStepLabel: {
    padding: 0,
  },
  customStepConnector: {
    display: 'none',
  },
  dashedLine: {
    width: 1,
    height: 36,
    border: '1.5px dashed #C9D5E3',
    marginInlineStart: '1rem',
    marginBlockStart: '0.5rem',
  },
}));

// Custom StepConnector component with vertical dashed line
const CustomStepConnector = withStyles((theme) => ({
  vertical: {
    padding: 0,
  },
  line: {
    borderLeftStyle: 'none',
    minHeight: 15,
    borderLeftWidth: 1,
  },
}))(StepConnector);

const CustomStepper = ({ status }) => {
  const classes = useStyles();
  const orderStatus = ['BEING_PREPARED', 'READY', 'ON_THE_WAY'];
  return (
    <div className={classes.container}>
      <Stepper
        orientation="vertical"
        className={classes.customStepper}
        connector={<CustomStepConnector />}
      >
        <Step>
          <div className={classNames(classes.circle, [])}>
            <TiTick className={classes.tickCustom} />
          </div>
        </Step>
        <div className={classes.dashedLine}></div>
        <Step>
          <div
            className={classNames(classes.circle, [
              orderStatus.includes(status) ? classes.activatedCircle : classes.inactivatedCircle,
            ])}
          >
            <TiTick className={classes.tickCustom} />
          </div>
        </Step>
        <div className={classes.dashedLine}></div>
        <Step>
          <div
            className={classNames(classes.circle, [
              status === 'ON_THE_WAY' ? classes.activatedCircle : classes.inactivatedCircle,
            ])}
          >
            <TiTick className={classes.tickCustom} />
          </div>
        </Step>
      </Stepper>
    </div>
  );
};

export default CustomStepper;
